export default __webpack_public_path__ + "static/media/star_big_white.56a2374d.svg";